import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  dropdown: {
    width: '100%',
    backgroundColor: 'transparent',
  },
  placeholderStyle: {
    fontSize: 16,
    opacity: 0.5,
  },
  selectedTextStyle: {
    fontSize: 14,
    color: colors.newUI.therapist.primaryBlue80,
  },
  iconStyle: {
    width: 35,
    height: 35,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
    borderWidth: 0,
    borderColor: 'none',
  },
  icon: {
    marginRight: 5,
  },
  selectedStyleMultiSelect: {
    borderRadius: 8,
    backgroundColor: 'white',
    borderColor: colors.newUI.therapist.blue50,
    borderWidth: 1,
    marginTop: 0,
    marginBottom: 0,
    marginRight: 8,
    flexDirection: 'row',
    paddingVertical: 5,
    paddingHorizontal: 8,
    gap: 8,
  },
  selectedStyle: {
    marginTop: 0,
    marginBottom: 0,
    flexDirection: 'row',
    paddingVertical: 5,
    paddingHorizontal: 8,
    gap: 8,
  },
  container: {
    marginBottom: 16,
    minWidth: 50,
  },
  label: {
    fontSize: 16,
    fontWeight: '600',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: 8,
  },
  required: {
    color: colors.newUI.therapist.red70,
  },
  info: {
    fontSize: 14,
    fontWeight: '400',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: 8,
  },
  outer: {
    borderRadius: 8,
    padding: 2,
    borderWidth: 2,
    borderColor: 'transparent',
    marginLeft: -2,
  },
  outerFocused: {
    borderWidth: 2,
    borderColor: colors.newUI.therapist.blue50,
  },
  inner: {
    backgroundColor: colors.newUI.therapist.bgBlue10,
    paddingTop: 8,
    paddingBottom: 4,
    paddingLeft: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 2,
    height: 60,
  },
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
    paddingHorizontal: 16,
    backgroundColor: '#fff',
    borderColor: colors.newUI.therapist.primaryBlue10,
    borderBottomWidth: 1,
  },
  labelWrapper: {
    flexShrink: 1,
  },
  itemLabel: {
    fontSize: 14,
    color: '#333',
    paddingHorizontal: 8,
    paddingVertical: 8,
  },
  itemLabelMultiSelect: {
    fontSize: 14,
    color: '#333',
    paddingHorizontal: 8,
    paddingVertical: 8,
    borderColor: colors.newUI.therapist.blue90,
    borderWidth: 1,
    borderRadius: 8,
  },
  itemLabelSelected: {
    borderColor: colors.newUI.therapist.blue50,
    borderWidth: 1,
    borderRadius: 8,
  },
  checkIcon: {
    marginLeft: 8,
    marginRight: 5,
  },
  containerStyle: {
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    borderColor: colors.newUI.therapist.primaryBlue80,
    borderWidth: 1,
    overflow: 'hidden',
    backgroundColor: '#fff',
  },
  iconWrapper: {
    backgroundColor: '#E5F0FF',
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
  },
  statusCircle: {
    width: 32,
    height: 32,
    borderRadius: 32,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
  },
  rightIconWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  disabledItemWrapper: {
    paddingVertical: 5,
  },
  disabledItem: {
    color: colors.newUI.therapist.grey60,
  },
});
